module.exports = __webpack_public_path__ + "img/poster1.3804ff93.png";